import { Component } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { HeaderService } from './shared/services/header.service';
import { LayoutService } from './shared/services/layout.service';
@Component({
  standalone:false,
  selector: 'tde-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  constructor(
    private readonly _router: Router,
    private readonly _activatedRoute: ActivatedRoute,
    private readonly _layoutService: LayoutService,
    private readonly _headerService: HeaderService
  ) {
    _router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this._headerService.setPageTitles([]);
      });
  }

  ngOnInit() {
    this._activatedRoute.queryParamMap.subscribe((p) => {
      if (p['params'].hasOwnProperty('layout')) {
        this._layoutService.setLayoutVisibility(
          p['params']['layout'] != 'false'
        );
      }
    });
  }
}
